export default function hasPermission(perms) {
  let hasTag = false
  let arr = perms.split(",")
  //获取用户的按钮权限
  let permissions = JSON.parse(sessionStorage.getItem("rolesList"))
  for (let j = 0; j < arr.length; j++) {
    let flag = false
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i] === arr[j]) {
        flag = true
        break
      }
    }
    if (flag) {
      hasTag = true
    } else {
      hasTag = false
      break
    }
  }
  return hasTag
}

// export default function hasPermission(perms) {
//   let hasTag = false
//   //获取用户的按钮权限
//   let permissions = JSON.parse(sessionStorage.getItem("rolesList"))
//   for (let i = 0; i < permissions.length; i++) {
//     if (permissions[i] === perms) {
//       hasTag = true
//       break
//     }
//   }
//   return hasTag
// }
